import Dialog from '../../../components/UI/Dialog/Dialog';
import Title from '../../../components/UI/Title/Title';
import useTranslations from '../../../hooks/useTranslations';

import './ActiveOrderDialog.scss';

interface IActiveOrderDialogProps {
  customerName: string;
  phoneNumber: string;
  activeOrderId: string | number;
  onClose: () => void;
  onNavigateToOrder: () => void;
}

const ActiveOrderDialog = ({
  customerName,
  phoneNumber,
  activeOrderId,
  onClose,
  onNavigateToOrder,
}: IActiveOrderDialogProps) => {
  const { rcTranslate } = useTranslations();

  const renderDialogBody = () => {
    return (
      <div className="activeOrderDialog__content">
        <Title
          text={'customerAssignments.activeOrder.message'}
          parameters={[
            { label: 'name', value: customerName },
            { label: 'phone', value: phoneNumber },
            { label: 'activeOrderId', value: activeOrderId },
          ]}
          className="activeOrderDialog__message"
        />
      </div>
    );
  };

  return (
    <Dialog
      className="activeOrderDialog"
      title={rcTranslate('customerAssignments.activeOrder.title')}
      body={renderDialogBody()}
      onClose={onClose}
      onConfirm={onNavigateToOrder}
      confirmTitle={'customerAssignments.activeOrder.goToOrder'}
      closeTitle={'customerAssignments.activeOrder.understand'}
    />
  );
};

export default ActiveOrderDialog;
